import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a.map((r, i) => ({ ...r, name: String(i + 1) }));
};

const REELS = [
  { id: 'lt-bedroom', name: '1' },
  { id: 'lt-entire-house', name: '2' },
  { id: 'lt-kitchen', name: '3' },
  { id: 'lt-living-room', name: '4' },
  { id: 'kharghar-3bhk', name: '5' },
  { id: 'cf-bedroom-1', name: '6' },
  { id: 'cf-bedroom-2', name: '7' },
  { id: 'cf-bedroom-3', name: '8' },
  { id: 'cf-bedroom-4', name: '9' },
  { id: 'cf-living-room-1', name: '10' },
  { id: 'cf-living-room-2', name: '11' },
  { id: 'and-bedroom-1', name: '12' },
  { id: 'and-bedroom-2', name: '13' },
  { id: 'and-bedroom-4', name: '14' },
  { id: 'business-elite-1', name: '15' },
  { id: 'omkar-teaser', name: '16' },
  { id: 'omkar-living-room-1', name: '17' },
  { id: 'omkar-living-room-2', name: '18' },
  { id: 'omkar-master-bedroom', name: '19' },
  { id: 'aba-teaser', name: '20' },
  { id: 'aba-2nd-floor-1', name: '21' },
  { id: 'aba-2nd-floor-3', name: '22' },
  { id: 'aba-4th-floor-1', name: '23' },
  { id: 'aba-4th-floor-2', name: '24' },
  { id: 'complementary', name: '25' },
  { id: 'pavilion-bedroom-1', name: '26' },
  { id: 'pavilion-bedroom-2', name: '27' },
  { id: 'pavilion-bedroom-3', name: '28' },
  { id: 'pavilion-bedroom-4', name: '29' },
  { id: 'pavilion-combined', name: '30' },
  { id: 'pavilion-complimentary', name: '31' },
  { id: 'pavilion-kitchen', name: '32' },
  { id: 'pavilion-living-room-1', name: '33' },
  { id: 'pavilion-living-room-2', name: '34' },
  { id: 'jbcn-school', name: '35' },
  { id: 'oberoi-guest-bedroom', name: '36' },
  { id: 'oberoi-kitchen', name: '37' },
  { id: 'oberoi-living-room-1', name: '38' },
  { id: 'oberoi-living-room-2', name: '39' },
  { id: 'oberoi-parents-bedroom', name: '40' },
  { id: 'oberoi-master-bedroom', name: '41' },
  { id: 'kaizaad-complimentary', name: '42' },
  { id: 'mumbai-emporio-1', name: '43' },
];

const Reels = () => {
  const [reels] = useState(() => shuffle(REELS));
  return (
    <div data-testid="reels-page">
      <div className="px-4 sm:px-8 md:px-12 pt-8 pb-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {reels.map((reel) => (
            <div key={reel.id} data-testid={`reel-card-${reel.id}`}>
              <div className="relative aspect-[9/16] bg-gray-100 overflow-hidden">
                <video
                  className="w-full h-full object-cover"
                  controls
                  controlsList="nodownload nofullscreen noremoteplayback"
                  disablePictureInPicture
                  onDoubleClick={(e) => e.preventDefault()}
                  playsInline
                  preload="none"
                  poster={`${API_URL}/api/reels/${reel.id}/poster`}
                  src={`${API_URL}/api/reels/${reel.id}.mp4`}
                  onContextMenu={(e) => e.preventDefault()}
                  data-testid={`reel-video-${reel.id}`}
                />
              </div>
              <div className="tile-label mt-2">{reel.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Reels;
